"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEW_STYLE_GRID = exports.VIEW_STYLE_LIST = void 0;
const VIEW_STYLE_LIST = 'VIEW_STYLE_LIST';
exports.VIEW_STYLE_LIST = VIEW_STYLE_LIST;
const VIEW_STYLE_GRID = 'VIEW_STYLE_GRID';
exports.VIEW_STYLE_GRID = VIEW_STYLE_GRID;